// Custom overlay arrows for product gallery
// NOTE: These arrows advance images by clicking thumbnails.
// Do not remove unless replacing gallery UX.

(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function findMediaGallery() {
    return document.querySelector("media-gallery");
  }

  function ensureWrapper(mainGallery) {
    let wrapper =
      mainGallery.closest(".product__media-list-wrapper") ||
      mainGallery.parentElement;

    if (!wrapper || wrapper === document.body) {
      wrapper = document.createElement("div");
      wrapper.className = "product__media-list-wrapper";
      mainGallery.parentNode.insertBefore(wrapper, mainGallery);
      wrapper.appendChild(mainGallery);
    } else {
      wrapper.classList.add("product__media-list-wrapper");
    }

    return wrapper;
  }

  function injectArrows(wrapper) {
    if (wrapper.querySelector(".bmj-gallery-arrow")) return null;

    const prev = document.createElement("button");
    prev.type = "button";
    prev.className = "bmj-gallery-arrow bmj-gallery-arrow--prev";
    prev.setAttribute("aria-label", "Previous image");
    prev.innerHTML = "‹";

    const next = document.createElement("button");
    next.type = "button";
    next.className = "bmj-gallery-arrow bmj-gallery-arrow--next";
    next.setAttribute("aria-label", "Next image");
    next.innerHTML = "›";

    // Prevent opening the magnify modal
    [prev, next].forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
      btn.addEventListener("pointerdown", (e) => e.stopPropagation());
      btn.addEventListener("mousedown", (e) => e.stopPropagation());
    });

    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    return { prev, next };
  }

  function getThumbnailButtons(mediaGallery) {
    // Dawn-style thumbnails UL id: Slider-Thumbnails-template--...__main
    const thumbsList = mediaGallery.querySelector(
      'ul[id^="Slider-Thumbnails-"]'
    );
    if (!thumbsList) return [];

    // Thumbnails are usually buttons or anchors within the list
    const buttons = Array.from(
      thumbsList.querySelectorAll("button, a")
    ).filter((el) => {
      // filter out the thumbnail scroller arrow buttons
      const cls = (el.className || "").toString();
      if (cls.includes("slider-button")) return false;
      return true;
    });

    return buttons;
  }

  function findActiveThumbIndex(buttons) {
    // Common ways themes mark the active thumbnail:
    // - aria-current="true"
    // - class contains "is-active" or "active"
    // - parent li has "is-active"
    let idx = buttons.findIndex(
      (b) => b.getAttribute("aria-current") === "true"
    );
    if (idx >= 0) return idx;

    idx = buttons.findIndex((b) => {
      const cls = (b.className || "").toString().toLowerCase();
      if (cls.includes("active") || cls.includes("is-active")) return true;
      const li = b.closest("li");
      if (!li) return false;
      const lic = (li.className || "").toString().toLowerCase();
      return lic.includes("active") || lic.includes("is-active");
    });

    return idx >= 0 ? idx : 0;
  }

  function clickThumb(buttons, targetIndex) {
    if (!buttons.length) return false;
    const el = buttons[targetIndex];
    if (!el) return false;

    el.click();

    // If thumbs are scrollable, bring the active thumb into view
    el.scrollIntoView?.({ behavior: "smooth", block: "nearest", inline: "nearest" });
    return true;
  }

  function bind(arrows, mediaGallery) {
    if (!arrows) return;

    arrows.prev.addEventListener("click", () => {
      const buttons = getThumbnailButtons(mediaGallery);
      if (!buttons.length) return;

      const active = findActiveThumbIndex(buttons);
      const target = active - 1 < 0 ? buttons.length - 1 : active - 1;
      clickThumb(buttons, target);
    });

    arrows.next.addEventListener("click", () => {
      const buttons = getThumbnailButtons(mediaGallery);
      if (!buttons.length) return;

      const active = findActiveThumbIndex(buttons);
      const target = active + 1 >= buttons.length ? 0 : active + 1;
      clickThumb(buttons, target);
    });
  }

  ready(function () {
    const mediaGallery = findMediaGallery();
    if (!mediaGallery) return;

    // Main gallery UL id: Slider-Gallery-template--...__main
    const mainGallery = mediaGallery.querySelector(
      '[id^="Slider-Gallery-template--"][id$="__main"]'
    );
    if (!mainGallery) return;

    const wrapper = ensureWrapper(mainGallery);
    const arrows = injectArrows(wrapper);
    bind(arrows, mediaGallery);
  });
})();
